export default {
  '确认登出吗？': 'Are you sure to logout?',
  '多语言': 'Languages',
  '多语言配置，当页面需要支持多语言切换时，可使用此组件类配置静态多语言数据': '多语言配置，当页面需要支持多语言切换时，可使用此组件类配置静态多语言数据',
  '多语言配置': 'Language settings',
  '内容区': 'Content area',
  '子组件文案': 'Subcomponent text',
  '清空语言设置': 'Clear language settings',
  '遍历收集': 'Collect',
  '中英文': '中英文',
  '中文': 'Chinese',
  '选择': 'Choose',
  '接口选择': 'Choose API',
  '接口名称': 'API name',
  '模块': 'Module',
  'HTTP方法': 'HTTP method',
  '接口类型': 'API type',
  '操作': 'Action',
  '接口查询': 'Search',
  '数据库': 'Database',
  '查询': 'Search',
  '上下结构': '上下结构',
  '上左右结构': '上左右结构',
  '深色': 'dark',
  '浅色': 'light',
  '待发布': 'Wait',
  '已发布': 'Released',
  '已取消': 'Canceled',
  '默认': 'Default',
  '从外链加载': 'Load from link',
  '从文件加载': 'Load from file',
  '菜单': 'Menu',
  '按钮': 'Button',
  '是': 'Yes',
  '否': 'No',
  '登录认证': 'Authentication',
  '无验证': 'Without auth check',
  '工作台': 'Workplace',
  '应用编辑器': 'App editor',
  '新增目录': 'Add folder',
  '确认删除吗？': 'Are you sure to delete data？',
  '编辑': 'Edit',
  '设计': 'Design',
  '页面说明': 'Page descriptions',
  '删除': 'Delete',
  '新增子目录': 'Add subfolder',
  '新增子页面': 'add subpage',
  '应用名称': 'App name',
  '新增': 'Add',
  '主页': 'Homepage',
  '数据源': 'Datasource',
  '接口管理': 'API management',
  '共n条数据': 'total:{0}',
  '应用描述': 'App detail',
  '应用ID': 'App ID',
  '应用密钥': 'App secret',
  '主题': 'Theme',
  '状态': 'Status',
  '获取数据失败': 'It\'s failed to load data',
  '编辑器': 'Editor',
  '电脑': 'PC',
  '手机': 'Phone',
  '预览': 'Preview',
  '保存': 'Save',
  '发布': 'Release',
  '确认发布吗？': 'Are you sure to release？',
  '发布成功': 'Success',
  '发布失败': 'Failed',
  '保存成功': 'Success',
  '保存失败': 'Failed',
  '取消': 'Cancel',
  '基础信息': 'Basic information',
  '功能': 'Function',
  '权限字符': 'Permission key',
  '数据范围': 'Datascope',
  '类型': 'type',
  '主机': 'host',
  '端口': 'port',
  '服务名': 'Service name',
  '相关表信息': 'Table information',
  '添加表': 'Add table',
  '参数名可不设置，若进行设置，则设置参数名后，对应表的查询条件应该在键为该参数名的json对象中；该表的返回数据也会在键为该参数名的json对象中。': '参数名可不设置，若进行设置，则设置参数名后，对应表的查询条件应该在键为该参数名的json对象中；该表的返回数据也会在键为该参数名的json对象中。',
  '参数名': 'Parameter\'s name',
  '当同一个表添加多次时，可对这些表设置别名以进行区分': '当同一个表添加多次时，可对这些表设置别名以进行区分',
  '表别名': 'Alias of the table',
  '表关联关系': 'Relationship of the tables',
  '添加关联字段': 'Add parameters',
  '相等': 'Equals',
  '查询参数信息': 'Parameters information',
  '添加参数': 'Add parametes',
  '排序信息': 'Order information',
  '升序': 'ASC',
  '降序': 'DESC',
  '返回字段信息': 'Response params information',
  '更新字段信息': 'Update params information',
  '插入字段信息': 'Insert params information',
  '本部门': 'Self department',
  '本人': 'Self',
  '字段名': 'Parameter\'s name',
  '对应表': 'Table',
  '对应表字段': 'Parametes of the table',
  '字段描述': 'Descriptions of the parameters',
  '条件': 'Condition',
  '表': 'Table',
  '字段': 'Parameter',
  '字段类型': 'Parameter type',
  '表名': 'Table\'s name',
  '被关联表名': 'Table\'s name that related',
  '被关联字段': 'Parameter\'s name that related',
  '关联方式': 'Related type',
  '请输入': 'Please enter',
  '请选择': 'Please choose',
  '与主表关系': 'The relationship with the main table',
  '备注': 'remark',
  '主表': 'Main table',
  '从表': 'Subtable',
  '请选择数据库': 'Choose database',
  '请选择数据表': 'Choose table',
  '请添加相关表信息': 'Add table',
  '请设置关联字段': 'Add parameters',
  '字段名不可为空': 'Parameter\'s name can not be null',
  '接口地址': 'API URL',
  '地址': 'Address',
  '测试环境': 'Dev',
  '预发布环境': 'Beta',
  '生产环境': 'Production',
  '删除失败': 'Failed to delete',
  '获取数据失败': 'Failed to load data',
  '数据库配置': 'Database configration',
  '测试连接': 'Test connection',
  '数据库类型': 'Database type',
  '用户名': 'Username',
  '密码': 'Password',
  '选择字段': 'Choose parameters',
  '选择数据表': 'Choose tables',
  '可否为空': 'If can be null',
  '可空': 'can be null',
  '非空': 'can not be null',
  '默认值': 'Default value',
  '编辑应用': 'Edit',
  '新增应用': 'Add',
  '应用图标': 'Icon',
  '选择图标': 'Choose icon',
  '应用布局': 'Layout',
  '父目录': 'Parent Folder',
  '目录名称': 'Folder\'s name',
  '排序': 'Order',
  '无': 'None',
  '目录': 'Folder',
  '页面名称': 'Page\'s name',
  '英文名': 'English name',
  '页面加载方式': 'Load type',
  '外链地址': 'link',
  '页面文件': 'file',
  '页面信息': 'page',
  '确定': 'sure',
  '页面目录': 'folder',
  '页面地址': 'url',
  '二维码': 'QRCode',
  '下载': 'download',
  '部门名称': 'Department\'s name',
  '部门编码': 'Department\'s code',
  '应用': 'App',
  '成员': 'Members',
  '字典名称': 'Dictionary\'s name',
  '字典编码': 'Dictionary\'s code',
  '内容': 'Content',
  '标题': 'Title',
  '业务类型': 'Business type',
  '请求方法': 'Request method',
  '操作人': 'Operator',
  '请求时间': 'Request time',
  '响应时间': 'Response time',
  '返回状态': 'Response status',
  '菜单名称': 'Menu\'s name',
  '菜单类型': 'Menu\'s type',
  '菜单标识': 'Menu\'s code',
  '组件': 'Component',
  '访问地址': 'URL',
  '权限字符': 'Permission keys',
  '验证类型': 'Auth type',
  '顺序号': 'Sort number',
  '角色名称': 'Role\'s name',
  '角色标识': 'Role\'s code',
  '权限': 'Permission',
  '用户名称': 'Username',
  '设置密码': 'Set password',
  '设置角色': 'Set role',
  '登录账号': 'Account',
  '角色': 'Role',
  '正常': 'Normal',
  '禁用': 'Disabled',
  '添加部门': 'Add department',
  '编辑部门': 'Edit department',
  '所属应用': 'Belongs app',
  '上级部门': 'Parent department',
  '添加用户': 'Add user',
  '账号状态': 'Account status',
  '账户名': 'Account',
  '请选择要添加的用户': 'Choose users',
  '添加用户成功': 'Success',
  '添加用户失败': 'Failed',
  '部门成员': 'Members',
  '编辑字典内容信息': 'Edit',
  '新增字典内容信息': 'Add',
  '所属字典': 'Belongs dictionary',
  '英文标题': 'Title in english',
  '值': 'value',
  '字典内容': 'Content of the dictionary',
  '内容英文': 'Content in english',
  '编辑字典信息': 'Edit',
  '新增字典信息': 'Add',
  '日志信息': 'Log',
  '链接地址': 'Url',
  '请求IP': 'IP',
  '操作系统': 'OS',
  '浏览器': 'Browser',
  '编辑菜单信息': 'Edit',
  '新增菜单信息': 'Add',
  '上级菜单': 'Parent menu',
  '绑定页面': 'Bind page',
  '验证方式': 'Auth type',
  '选择菜单': 'Choose menu',
  '编辑角色信息': 'Edit',
  '新增角色信息': 'Add',
  '角色名称': 'Role\'s name',
  '角色标识': 'Role\'s code',
  '编辑用户信息': 'Edit',
  '新增用户信息': 'Add',
  '姓名': 'Name',
  '登录名': 'Account',
  '确认密码': 'Verify password',
  '密码不一致': 'The password is different',
  '登录失败': 'Login failed',
  '账号登录': 'Account login',
  '请输入账户名': 'Please input the account',
  '请输入密码': 'Please input the password',
  '登录': 'Login',
  '左右结构': '左右结构',
  '密钥信息': 'Security',
  '基础信息': 'Basic',
  '布局信息': 'Layout',
  '是否模板': 'Is template',
  '复制': 'Copy',
  '确认复制应用吗？': 'Are you sure to copy the app？',
  '操作成功': 'Success',
  '操作失败': 'Failed',
  '消息模板配置': 'Message template configuration',
  '消息模板': 'Message template',
  '触发类型': 'Trigger type',
  '触发接口地址': 'Trigger API',
  '模板内容': 'Template content',
  '新增': 'Add',
  '更新': 'Update',
  '序号': 'Index',
  '消息内容': 'Content',
  '创建时间': 'Create time',
  '导入': 'Import',
  '上传': 'Upload',
  '下载模板': 'Download template',
  '点击此处上传': 'Click here to upload file',
  '导入字典': 'Import dictionary data',
  '请按照模板要求，导入字典信息。': '请按照模板要求，导入字典信息。',
  '认证接口': 'Authorization API',
  '用户信息接口': 'User data API',
  '自定义': 'Custom',
  '系统权限': 'System menus',
  '系统菜单': 'System menus',
  '应用菜单': 'App menus',
  '是否发布': 'Release or not',
  '本部统一身份认证': 'Unified login（Harbin）',
  '校区统一身份认证': 'Unified login（ShenZhen）',
  '哈工大APP扫码登录': 'Harbin Institute ofTechnology APP CodeScanning Login',
  '用户咨询': 'Consultation',
  '统一身份认证登录失败': 'Unified login failed',
  '返回': 'Back',
}